/**
 * Hook to manage checkout session
 */

import { useEffect } from 'react';
import { useCheckoutStore } from '../stores/checkoutStore';

/**
 * Hook to load and manage checkout session
 */
export function useCheckoutSession(sessionId: string, organizationId?: string) {
  const { session, sessionLoading, sessionError, loadSession, clearSession, setOrganizationId } =
    useCheckoutStore();

  // Load session on mount or when sessionId changes
  useEffect(() => {
    if (!sessionId) {
      clearSession();
      return;
    }

    // Set organization ID if provided
    if (organizationId) {
      setOrganizationId(organizationId);
    }

    loadSession(sessionId).catch((error) => {
      console.error('Failed to load checkout session:', error);
    });
  }, [sessionId, organizationId, loadSession, clearSession, setOrganizationId]);

  // Check if session is expired
  const isExpired = session
    ? new Date(session.expires_at) < new Date()
    : false;

  return {
    session,
    loading: sessionLoading,
    error: sessionError,
    isExpired,
    isPending: session?.status === 'pending',
    isCompleted: session?.status === 'completed',
    isFailed: session?.status === 'failed',
  };
}
